import {
  // TYPESCRIPT TYPES
  DetailsPageActionTypes,
  DetailsStateShape,
  UPDATE_DETAILS_STATIC_DATA,
  UPDATE_DETAILS_HERMES_DATA,
  UPDATE_ABOUT_PROPERTY,

  // ACTION "type's" TYPES
  UPDATE_DETAILS_STATIC_FETCH_STATUS,
  UPDATE_DETAILS_HERMES_FETCH_STATUS,
  UPDATE_CURRENT_ROOM,
  UPDATE_DETAILS_CONFIG,
  UPDATE_UGC_IMAGES,
  RESET_DETAILS_DATA,
  UPDATE_RNR_PAGENO,
  UPDATE_HOTEL_POLICY_ADDITIONAL_DATA,
  UPDATE_HOTEL_POLICY_LIST,
  UPDATE_HOTEL_POLICY_ERROR,
  FetchStatusType,
  UPDATE_HOTEL_POLICY_FETCH_STATUS,
  UPDATE_SIMILAR_HOTELS_DATA,
  UPDATE_SIMILAR_HOTELS_ERROR,
  UPDATE_SIMILAR_HOTELS_FETCH_STATUS,
} from './types';
import {defaultSimilarHotelsAPIData} from '../utils/fetch-similar-hotels';

const detailsInitState: DetailsStateShape = {
  vhid: '',
  filter: {},
  selectedHotelStatic: {
    hn: '',
    hc: '',
    ibp: '',
    hmd: '',
  },
  hasStaticData: false,
  hasHermesData: false,
  isStaticDataLoading: false,
  isHermesDataLoading: false,
  staticData: {},
  hermesData: {
    data: {
      reg: [],
    },
    metaInfo: {},
  },
  UI: {
    currentRoomData: {},
  },
  processedAboutPropertyData: '',
  hotelPolicyData: {
    hotelPolicyList: [],
    hotelPolicyAdditionalData: {},
    hotelPolicyError: null,
    hotelPolicyFetchStatus: FetchStatusType.NOT_STARTED,
  },
  similarHotels: {
    list: defaultSimilarHotelsAPIData.data,
    cityMetaInfo: defaultSimilarHotelsAPIData.city_meta_info,
    error: null,
    fetchStatus: FetchStatusType.NOT_STARTED,
  },
};

export default function detailsReducer(state = detailsInitState, action: DetailsPageActionTypes) {
  switch (action.type) {
    case UPDATE_DETAILS_STATIC_FETCH_STATUS:
      return {
        ...state,
        isStaticDataLoading: action.payload.isLoading,
      };

    case UPDATE_DETAILS_HERMES_FETCH_STATUS:
      return {
        ...state,
        isHermesDataLoading: action.payload.isLoading,
      };

    case UPDATE_DETAILS_STATIC_DATA:
      return {
        ...state,
        staticData: action.payload.staticData,
        hasStaticData: true,
      };

    case UPDATE_DETAILS_HERMES_DATA:
      return {
        ...state,
        hermesData: action.payload.hermesData,
        hasHermesData: true,
      };

    // 🐨 UI state should be its own slice reducer
    // if UI state becomes a little bigger, slide it, else keep it this way only
    // in this reducer itself
    case UPDATE_CURRENT_ROOM:
      return {
        ...state,
        UI: {
          ...state.UI,
          currentRoomData: action.payload.roomData,
        },
      };

    case UPDATE_DETAILS_CONFIG:
      return {
        ...state,
        vhid: action.actionData.vhid,
        filter: action.actionData.filter,
        selectedHotelStatic: action.actionData.selectedHotelStatic,
        offerCodeFromQueryParam: action.actionData.offerCodeFromQueryParam,
        appliedFilters: action.actionData.appliedFilters,
      };

    case UPDATE_UGC_IMAGES:
      return {
        ...state,
        staticData: {
          ...state.staticData,
          ugc_images: action.actionData,
        },
      };

    case UPDATE_ABOUT_PROPERTY:
      return {
        ...state,
        processedAboutPropertyData: action.actionData,
      };

    case UPDATE_RNR_PAGENO:
      return {
        ...state,
        page: action.actionData,
      };

    case RESET_DETAILS_DATA:
      return {
        ...state,
        ...detailsInitState,
      };

    /** HOTEL POLICY */
    case UPDATE_HOTEL_POLICY_LIST:
      return {
        ...state,
        hotelPolicyData: {
          ...state.hotelPolicyData,
          hotelPolicyList: action.payload?.hotelPolicyList,
        },
      };

    case UPDATE_HOTEL_POLICY_ADDITIONAL_DATA:
      return {
        ...state,
        hotelPolicyData: {
          ...state.hotelPolicyData,
          hotelPolicyAdditionalData: action.payload?.hotelPolicyAdditionalData,
        },
      };

    case UPDATE_HOTEL_POLICY_ERROR:
      return {
        ...state,
        hotelPolicyData: {
          ...state.hotelPolicyData,
          hotelPolicyError: action.payload?.hotelPolicyError,
          hotelPolicyFetchStatus: FetchStatusType.REJECTED,
        },
      };

    case UPDATE_HOTEL_POLICY_FETCH_STATUS:
      return {
        ...state,
        hotelPolicyData: {
          ...state.hotelPolicyData,
          hotelPolicyFetchStatus: action.payload?.hotelPolicyFetchStatus,
        },
      };

    /** SIMILAR HOTELS */
    case UPDATE_SIMILAR_HOTELS_DATA:
      return {
        ...state,
        similarHotels: {
          ...state.similarHotels,
          list: action.payload?.list,
          cityMetaInfo: action.payload?.cityMetaInfo,
          fetchStatus: FetchStatusType.RESOLVED,
        },
      };

    case UPDATE_SIMILAR_HOTELS_ERROR:
      return {
        ...state,
        similarHotels: {
          ...state.similarHotels,
          error: action.payload?.error,
          fetchStatus: FetchStatusType.REJECTED,
        },
      };

    case UPDATE_SIMILAR_HOTELS_FETCH_STATUS:
      return {
        ...state,
        similarHotels: {
          ...state.similarHotels,
          fetchStatus: action.payload?.fetchStatus,
        },
      };

    default:
      return state;
  }
}
